<template>
  <div class="contract-page" v-loading="infoLoading">
    <div class="sec-hd">
      <h2 class="title">合同</h2>
      <!-- <div class="btn-group">
        <el-button type="primary" size="medium">查询</el-button>
        <el-button type="warning" size="medium">重置</el-button>
      </div> -->
    </div>
    <el-table
      :data="tableData"
      border
      class="table"
      header-row-class-name="head"
    >
      <el-table-column
        label="操作"
        width="80">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="look(scope.row)">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="contractNum"
        label="合同编号">
      </el-table-column>
      <el-table-column
        prop="contractName"
        label="合同名称">
      </el-table-column>
      <el-table-column
        prop="contractTypeName"
        label="分类">
      </el-table-column>
      <el-table-column
        prop="startTime"
        label="开始时间">
      </el-table-column>
      <el-table-column
        prop="endTime"
        label="结束时间">
      </el-table-column>
      <el-table-column
        prop="signInitiator"
        label="签署发起人">
      </el-table-column>
      <el-table-column
        prop="signingProgressName"
        label="状态">
      </el-table-column>
      <el-table-column
        prop="signer"
        label="签署人">
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :current-page.sync="pageNum"
      :page-size="pageSize"
      @current-change="loadList"
      :total="totalCount">
    </el-pagination>
  </div>
</template>
<script>
import {
  contracts,
  ConvertPDF
} from '@/service/customerInformation.js';
import API from '@/service/apiEnv';
export default {
  data(){
    return{
      infoLoading: false,
      tableData:[],
      filterForm:{
        contractName:'',
        contractType:'',
        startTime:'',
        endTime:'',
        signInitiator:'',
        signingProgress:'',
        signer:'',
      },
      pageSize:10,
      pageNum:1,
      totalCount:0,
    }
  },
  mounted() {
    this.loadList();
  },
  methods: {
    loadList(){
      let companyId=Number(this.$route.query.companyId);
      let params={
        ...this.filterForm,
        companyId:companyId,
        rational:true,
        pageNum:this.pageNum,
      }
      this.infoLoading = true
      contracts(params).then(r=>{
        this.infoLoading = false
        if(r.Result==1){
          let list=r.Data.datas || [];
          list.map((item)=>{
            item.startTime=item.startTime.substr(0,10);
            item.endTime=item.endTime.substr(0,10);
          })
          this.tableData=list;
          this.totalCount=r.Data.total;
        }
      })
    },
    look(item){
      if(!item.contractFileUrl){
        this.$message.info('没有合同文件！');
        return;
      }
          // var url=`${location.origin}/static/pdf/web/viewer.html?file=${path}`;
          // window.open(url,'newWin');
      let _path=item.contractFileUrl.replace('http://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/', '');
      _path=_path.replace('http://oss.insupai.com/','')
      ConvertPDF({
        filePath:_path,
        platform:'pcweb'
      }).then(r=>{
        if(r.Result==1){
          var path=encodeURIComponent(r.Data);
          var url=`${API.api4}/pdf/web/viewer.html?file=${path}`;
          window.open(url,'newWin');
        }else{
          this.$message.warn(r.Message);
        }
      })
    }
  },
}
</script>
<style lang="scss">
.contract-page{
  .sec-hd{
		overflow: hidden;
		margin-bottom: 20px;
		.title{
			font-size: 18px;
			color: #333;
			line-height: 40px;
			font-weight: bold;
      float: left;
		}
    .btn-group{
      float: right;
    }
	}
  .table{
    width: 100%;
    .head th{
      background-color: #f9f9f9;
    }
  }
}
</style>